import { bus } from "@/main";
import { userLogin } from "@/data/connection";
import VueCookies from "vue-cookies";
import { deleteSession } from "../../../data/authentication";

export default {
	name: "LoginBlock",
	data() {
		return {
			user: null,
			openMenu: false,
		}
	},
	props: [
	],
	created() {
		this.getUser()
		bus.$on("deleteSession", () => {
			this.user = null;
		})
		bus.$on("userSession", () => {
			this.getUser()
		})
	},
	watch: {},
	computed: {},
	methods: {
		getUser() {
			this.user = VueCookies.get("user")
		},
		logOut() {
			deleteSession()
			this.user = null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/login-block/login.block.js